<template>
  <div class="animated fadeIn list-of-cashflow">
    <b-card>
      <div slot="header">REPORT GL - ACCOUNT CASH/BANK  
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="print()">
              <i class="fa fa-print"></i> Print
          </button>
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="6">
          <b-input-group >
              <b-input-group-prepend><label>Cash/bank Account</label></b-input-group-prepend>
              <b-form-input readonly v-model="model.namabank" @keyup.13.native="lkuBankaccountShow=true" :state="!$v.model.kodebank.$error"></b-form-input>
              <b-input-group-append>
                  <b-btn text="Button" @click="lkuBankaccountShow=true">
                      <i class="fa fa-search"></i>
                  </b-btn>
              </b-input-group-append>
              <b-input-group-append><span class="pt-2 ml-2 mr-1">GL Account#</span></b-input-group-append>
              <b-input-group-append>
                  <span class="input-group-text" style="min-width:150px;">{{model.kodeacc}}</span>
              </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group >
            <b-input-group-prepend><span class="pt-2 mr-1">Trx. Date Range</span></b-input-group-prepend>
            <b-form-input v-model="model.tgl1" type="date" ></b-form-input>
            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="model.tgl2" type="date" ></b-form-input>
            <b-form-checkbox class="ml-1 mt-2 text-left" v-model="model.noDim" value=0 unchecked-value=1>With Dimension</b-form-checkbox>
            <b-input-group-append ><b-button class="ml-2 btn btn-success mr-2" @click="process()" > <i class="fa fa-play"></i> Process</b-button></b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body>
          <!-- <template v-slot:header v-if="(filterShow=='Hide')">          
            <b-row >
                <b-col lg="3">
                  <b-input-group size="sm" class="mt-1">
                    <b-input-group-prepend><span class="pt-1 mr-1" >FILTER</span></b-input-group-prepend>
                    <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                        ></b-form-input>
                    <b-input-group-append>
                    <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                    </b-input-group-append>
                    </b-input-group>
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>

                </b-col> 
                <b-col lg="9">
                  <b-form-group
                    label="FILTER ON :"
                    label-cols-sm="1"
                    description="Leave all unchecked to filter on all data"
                    class="mb-0">
                    <b-form-checkbox-group v-model="filterOn" class="mt-1">
                      <b-form-checkbox value="uraian">Description</b-form-checkbox>
                      <b-form-checkbox value="paymethod">Payment Method</b-form-checkbox>
                      <b-form-checkbox value="terimadari">From/to Payee </b-form-checkbox>
                      <b-form-checkbox value="trxgroups">Trx.Group (AP/AR,..)</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>                
                </b-col>                 
            </b-row>
        </template> -->
        <b-table
            class="mb-0"
            ref="tableOri"
            sticky-header="600px" outlined responsive striped hover
            style="font-size:smaller;"
            :items="rptLines"
            :fields="tblFields"
            :current-page="tblLcy.page"
            :per-page="tblLcy.limit"
            :sort-by.sync="tblLcy.sortBy"
            :sort-desc.sync="tblLcy.sortDesc"
            :filter="filterInput"
            :filterIncludedFields="filterOn"
            @filtered="onFiltered"                
        >
          <template v-slot:cell(tanggal)="data">
              {{ data.item.tanggal | moment("DD-MMM-YYYY") }}
              <!-- <span v-if="(data.item.tanggal)">{{ data.item.tanggal | moment("DD-MMM-YYYY") }}</span> -->
          </template>
            <template v-slot:cell(nomor)="data">
                    <span v-if="(data.item.nomor=='BEGINING')">{{data.item.nomor}}</span>
                    <span v-else ><b-link @click.stop="printJv(data.item)">{{data.item.nomor}}</b-link></span>
            </template>

            <template v-slot:cell(umasuk)="data">
                  {{ data.item.umasuk | numFormat }}
            </template>
            <template v-slot:cell(ukeluar)="data">
                  {{ data.item.ukeluar | numFormat }}
            </template>
            <template v-slot:cell(sakhir)="data">
                  {{ data.item.sakhir | numFormat }}
            </template>
        </b-table>
        <b-row class="m-1">
          <b-col lg="6">            
            <b-row v-if="(filterShow=='Hide')">
                  <b-input-group size="sm">
                      <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch></b-form-checkbox>
                        <b-input-group-prepend> <span class="pr-2">
                            <b> {{ filterShow }}</b>  Filter </span>
                        </b-input-group-prepend>
                      <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                  </b-input-group>
                  <b-input-group size="sm" class="ml-4">
                      <b-input-group-prepend class="ml-5"> <span class="pr-2">On</span>
                      </b-input-group-prepend>
                      <b-form-checkbox-group v-model="filterOn" class="mt-1">
                        <b-form-checkbox value="nomor">Voucher Number</b-form-checkbox>
                        <b-form-checkbox value="uraian">Description</b-form-checkbox>
                        <b-form-checkbox value="umasuk">Debit Amount</b-form-checkbox>
                        <b-form-checkbox value="ukeluar">Credit Amount</b-form-checkbox>
                      </b-form-checkbox-group>
                  </b-input-group>
                  <label class="text-muted small" style="margin-left:100px;">Leave all unchecked to filter on all data</label>
            </b-row>
            <b-row v-else>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch >
                <b> {{ filterShow }}</b>  Filter
              </b-form-checkbox>
            </b-row>
          </b-col>
          <b-col lg="6">
            <div style="display: flex;margin:0;padding:0;">
                <div style="margin:0;padding:5px;width:500px; text-align:right;">
                    Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to <span v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)">{{tblLcy.total}}</span> <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} ,   <span class="mr-1">limit per page :</span> 
                    <select  v-model="tblLcy.limit"  style="width:60px;">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>                            
                      <option>25</option>
                      <option>30</option>                            
                      <option>40</option>                            
                      <option>50</option>                            
                      <option>60</option>                            
                      <option>70</option>                            
                      <option>80</option>                            
                      <option>90</option>                            
                    </select>
                </div>
                <div>
                    <b-pagination  class="ml-1" 
                      align="left"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                </div>
            </div>
          </b-col>
        </b-row>
      </b-card>

    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
        <lku-bankaccount @click="onSelectLkuBankaccount" :formdata="lkuBankaccountData" aktif=1></lku-bankaccount>
    </b-modal>        

  </div>
</template>

<style lang="scss" scoped>
 
</style>

<script>
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import buku from "../../apis/buku";
import gl from "../../apis/gl";
import lkuBankaccount from "../lookup/lkuBankaccountLazzy";
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
        kodebank: { required },
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      lkuBankaccountData:{},
      lkuBankaccountShow: false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      model: {kodebank:'',tgl1:'',tgl2:'', noDim:1},
      bankCashAcc: [],
      tahun:moment(this.$store.state.user.tglaktif).format('YYYY'),
      rptLines : [],
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
      filterShow:'Show',
      filter: null,
      filterOn: [],   
      filterInput:null
    };
  },
  components: {Loading,lkuBankaccount, myNumber},
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    tblFields(){
      const fields=[
          {
            key: "tanggal",
            label: "Trx. Date",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "nomor",
            label: "Trx. Number",
            sortable: true
          },
        {
          key: "uraian",
          label: "Description",
        },
        {
          key: "createby",
          label: "Create By",
          sortable: true
        },
        {
          key: "umasuk",
          label: "Debit (LCY)",
          thStyle: "width:140px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "ukeluar",
          label: "Credit (LCY)",
          thStyle: "width:140px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "sakhir",
          label: "End Balance  (LCY)",
          thStyle: "width:140px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },    

  },  
  watch:{
    filterShow: function(newval) {
      setTimeout(() => {
              this.filter=''
      }, 200);
    },
    filter: function(newval) {
      // this.isBusy=true;
      setTimeout(() => {
            this.filterInput=newval;
      }, 800);
    },
  },   
  created: async function(){
      // this.bankCashAcc = await cashflow.bankaccount();
        const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.model.tgl1=this.$store.state.user.tglaktif;
        this.model.tgl2=tgl2.format('YYYY-MM-DD');

  },  
  methods: {
    onSelectLkuBankaccount(lkuData) {
        this.lkuBankaccountData=lkuData;
        this.lkuBankaccountShow=false;
        this.model.kodebank=lkuData.selected.kode;
        this.model.matauang=lkuData.selected.matauang;
        this.model.namabank=lkuData.selected.namabank;
        this.model.namaacc=lkuData.selected.namabank || '';
        this.model.nomorrek=lkuData.selected.nomorrek;
        this.model.kodeacc=lkuData.selected.kodeacc;
        this.model.kodeaw=lkuData.selected.kodeacc;
        this.model.kodeak=lkuData.selected.kodeacc;
        this.lkuBankaccountShow=false;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
      // this.totalBank_in = filteredItems.reduce((a, b) => a + b.bank_in, 0);
      // this.totalBank_out = filteredItems.reduce((a, b) => a + b.bank_out, 0);
    },     
    clearFilter() {
          this.filterOn= []   
          this.filter= '';   
    } ,
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
      // this.totalUmasuk = filteredItems.reduce((a, b) => a + b.umasuk, 0);
      // this.totalUkeluar = filteredItems.reduce((a, b) => a + b.ukeluar, 0);
    },     
    clearFilter() {
          this.filterOn= []   
          this.filter= '';   
    } ,
    process: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.isLoading=true;
                const model = {};
                for (var key in this.model) {
                    model[key] = this.model[key];
                }
                model.tgl1= moment(this.model.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.model.tgl2).format('YYYY-MM-DD');                
        this.rptLines= await gl.rptgl(model);      
        this.tblLcy.total = this.rptLines.length;        
        this.isLoading=false;      
       }
    },

    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            try {
                this.showReport=true;
                const model = {};
                for (var key in this.model) {
                    model[key] = this.model[key];
                }
                model.tgl1= moment(this.model.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.model.tgl2).format('YYYY-MM-DD');
                this.reportUrl= await gl.rptglprint(model);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const model = {};
                for (var key in this.model) {
                    model[key] = this.model[key];
                }
                model.tgl1= moment(this.model.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.model.tgl2).format('YYYY-MM-DD');
                const response = await gl.rptglexport(model);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `GeneralLedger_${model.tgl2}.xlsx`);
                document.body.appendChild(link);
                link.click();

                this.isLoading=false;    
            } catch (error) {
              this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
       }
    },
    confirmAction: function() {
        toastr.info('Klik Pada kolom JV.NUMBER untuk PRINT VOUCHER');
    },
    printJv: async function(data){
       if ((data.kodeacc) && (data.nomor !== 'BEGINING') && (data.nomor !== '')) {
          try {
              this.reportUrl= await buku.printjv({ nomor: data.nomor, tanggal:moment(data.tanggal).format('YYYY-MM-DD'), kodejurnal: data.kodejurnal});
              this.showReport=true;
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } 
    },
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'accounting.gl')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        //   router.push("/accounting/home");
          router.push({path:"home"});
      }

    }
  }
};
</script>
